import { isPresentComponentValue } from "./listActiveComponentEntries";

/**
 * Filters out falsy and empty string values from an array of component values
 * @param values - Array of component values to filter
 * @returns Filtered array with only truthy, non-empty string values
 */
export const filterComponentValues = (values: string[]): string[] => {
  return values.filter(isPresentComponentValue);
};
